import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Login from './Login';
import DashboardLayout from './forms/DashboardLayout';
import ProtectedRoute from './ProtectedRoute';
import Report from './views/ReservoirStatistics';
// Commented out imports for other forms
// import ColoradoForm from './forms/ColoradoForm';
// import ReservoirStatsForm from './forms/ReservoirStatsForm';
// import Flows from './forms/Flows';
// import TexanaForm from './forms/TexanaForm';
// import WeatherForm from './forms/WeatherForm';
// import ChokeCanyonForm from './forms/ChokeCanyonForm';
// import WesleySealeDamForm from './forms/WesleySealeDamForm';
// import WesleySealeDamGatesForm from './forms/WesleySealeDamGatesForm';
import DailyFlowsForm from './forms/DailyFlowsForm';

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const session = localStorage.getItem('session');
    if (session) {
      setIsLoggedIn(true);
    }
    setIsLoading(false);
  }, []);

  const handleLogin = () => {
    setIsLoggedIn(true);
    localStorage.setItem('session', 'true');
  };

  const handleLogout = () => {
    localStorage.removeItem('session');
    localStorage.removeItem('username');
    localStorage.removeItem('userGroups');
    setIsLoggedIn(false);
  };

  if (isLoading) {
    return null; // Or a loading spinner
  }

  return (
    <Router>
      <Routes>
        {/* Login route - redirects to dashboard if already logged in */}
        <Route 
          path="/login" 
          element={
            isLoggedIn ? (
              <Navigate to="/dashboard" replace />
            ) : (
              <Login onLogin={handleLogin} />
            )
          } 
        />

        {/* Public route */}
        <Route path="/Report" element={<Report />} />
        
        {/* Protected dashboard routes */}
        <Route
          path="/dashboard"
          element={
            //<ProtectedRoute>
              <DashboardLayout onLogout={handleLogout} />
            //</ProtectedRoute>
          }
        >
          {/* Commented out routes for other forms */}
          {/* <Route path="colorado" element={<ColoradoForm />} /> */}
          {/* <Route path="res-stats" element={<ReservoirStatsForm />} /> */}
          {/* <Route path="flows" element={<Flows />} /> */}
          {/* <Route path="texana" element={<TexanaForm />} /> */}
          {/* <Route path="reservoir-weather" element={<WeatherForm />} /> */}
          {/* <Route path="choke-canyon" element={<ChokeCanyonForm />} /> */}
          {/* <Route path="wesley-seale-dam" element={<WesleySealeDamForm />} /> */}
          {/* <Route path="wesley-seale-gates" element={<WesleySealeDamGatesForm />} /> */}
          
          {/* Add new Daily Flows form route */}
          <Route path="daily-flows" element={<DailyFlowsForm />} />
          <Route index element={<></>} />
        </Route>
        
        {/* Root and catch-all routes - redirect to dashboard if logged in, otherwise to login */}
        <Route
          path="*"
          element={
            isLoggedIn ? (
              <Navigate to="/dashboard" replace />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
      </Routes>
    </Router>
  );
}

export default App;